/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_DTOs_Holidays_BulkUpdateHolidaysDto } from '../models/Routemize_DTOs_Holidays_BulkUpdateHolidaysDto';
import type { Routemize_DTOs_Holidays_CreateHolidayDto } from '../models/Routemize_DTOs_Holidays_CreateHolidayDto';
import type { Routemize_DTOs_Holidays_HolidayDto } from '../models/Routemize_DTOs_Holidays_HolidayDto';
import type { Routemize_DTOs_Holidays_UpdateHolidayDto } from '../models/Routemize_DTOs_Holidays_UpdateHolidayDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class HolidayService {
    /**
     * @param year
     * @returns Routemize_DTOs_Holidays_HolidayDto OK
     * @throws ApiError
     */
    public static getApiAppHolidayGetList(
        year?: number,
    ): CancelablePromise<Array<Routemize_DTOs_Holidays_HolidayDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/holiday/getList',
            query: {
                'year': year,
            },
        });
    }
    /**
     * @param id
     * @returns Routemize_DTOs_Holidays_HolidayDto OK
     * @throws ApiError
     */
    public static getApiAppHolidayGet(
        id: string,
    ): CancelablePromise<Routemize_DTOs_Holidays_HolidayDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/holiday/{id}/get',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns Routemize_DTOs_Holidays_HolidayDto OK
     * @throws ApiError
     */
    public static putApiAppHolidayUpdate(
        id: string,
        requestBody?: Routemize_DTOs_Holidays_UpdateHolidayDto,
    ): CancelablePromise<Routemize_DTOs_Holidays_HolidayDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/holiday/{id}/update',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns Routemize_DTOs_Holidays_HolidayDto OK
     * @throws ApiError
     */
    public static postApiAppHolidayCreate(
        requestBody?: Routemize_DTOs_Holidays_CreateHolidayDto,
    ): CancelablePromise<Routemize_DTOs_Holidays_HolidayDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/holiday/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAppHolidayDelete(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/holiday/{id}/delete',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppHolidayBulkUpdate(
        requestBody?: Routemize_DTOs_Holidays_BulkUpdateHolidaysDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/holiday/bulkUpdate',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
